import { hasConsent, OSANO_CATEGORY } from '../consent.js'

export const AD_ATTRIBUTION_SNAPSHOT_EVENT = 'ad_attribution_snapshot'
export const AD_ATTRIBUTION_SNAPSHOT_DOM_EVENT = 'consumer-request:ad-attribution-snapshot'

// Mounted on a hidden element inside the consumer request form (the form
// itself already carries HubSpotUtk). Pushes one bounded ad-attribution
// snapshot immediately before the final-step submit reaches LiveView: the
// listener sits on the form element, LiveView's own submit listener is on
// `window`, so this one fires first and both messages share the channel in
// order. Mount, reconnect, and destroy push nothing; no timers, ever.
const AdAttributionSnapshot = {
  mounted() {
    this.form = this.el.closest('form')
    this.handleSubmit = () => this.pushSnapshotIfFinal()
    this.form?.addEventListener('submit', this.handleSubmit)
  },

  reconnected() {
    // A new server process starts with no snapshot; re-evaluate consent so a
    // denial since mount drops memory and a grant re-reads the current URL.
    try {
      adClickIdStore()?.applyConsent({ granted: marketingConsentGranted() })
    } catch {
      // Never let attribution interfere with the transport rejoin.
    }
  },

  destroyed() {
    this.form?.removeEventListener('submit', this.handleSubmit)
  },

  pushSnapshotIfFinal() {
    try {
      // Both values are bootstrapped by the page that rendered this element:
      // the flag mirrors the server's capture switch, and app.js only creates
      // the store while it is on. Without either there is no attribution for
      // this request, never a blocked submit.
      if (window.ADS_CONVERSIONS_CAPTURE_ENABLED !== true) return
      if (this.el.dataset.finalSubmission !== 'true') return

      const store = adClickIdStore()
      if (!store) return

      const payload = store.snapshot({
        osanoDisabled: Boolean(window.OSANO_DISABLED),
        hasMarketingConsent: hasConsent(OSANO_CATEGORY.MARKETING),
      })

      this.pushEvent(AD_ATTRIBUTION_SNAPSHOT_EVENT, payload)
      this.el.dispatchEvent(
        new CustomEvent(AD_ATTRIBUTION_SNAPSHOT_DOM_EVENT, { bubbles: true, detail: payload }),
      )
    } catch {
      // A failed snapshot means no attribution for this request, never a
      // blocked submit.
    }
  },
}

// app.js owns the store: created at load (only while capture is enabled) and
// fed from the Osano consent callback.
function adClickIdStore() {
  return window.consumerMarketingAdClickIdStore || null
}

function marketingConsentGranted() {
  return Boolean(window.OSANO_DISABLED) || hasConsent(OSANO_CATEGORY.MARKETING)
}

export default AdAttributionSnapshot
